export default __webpack_public_path__ + "static/media/B126.12070637.png";